(function(){
  function initEdit(root){
    var section = root.querySelector('[data-vp-edit]');
    if(!section || section.dataset.vpInit) return;
    section.dataset.vpInit = '1';
    initSwatches(section);

    var targets = section.querySelectorAll('.vp-reveal');
    if(!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches){
      targets.forEach(function(el){ el.classList.add('in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){ entry.target.classList.add('in'); io.unobserve(entry.target); }
        });
      }, {threshold:0, rootMargin:'0px 0px -8% 0px'});
      targets.forEach(function(el){ io.observe(el); });
      setTimeout(function(){ targets.forEach(function(el){ el.classList.add('in'); }); }, 3800);
    }
  }
  /* ---- Metal swatches -------------------------------------------------
     A chip carries the variant's price, material line, url and photograph, so
     choosing one switches the card to that variant rather than only tinting
     the picture. The first chip is marked on at render, and every value it
     needs is already in the DOM -- nothing is fetched.

     The card is not a link here (only the title and the CTA are), so the
     click does not have to be stopped from navigating; it is stopped anyway,
     because a chip inside a future card wrapper should never follow it. */
  var METAL_RE = /\b(1[048]\s?k(?:t)? gold|yellow gold|rose gold|white gold|sterling silver|oxidi[sz]ed silver|silver|gold)\b/i;

  function initSwatches(section){
    section.querySelectorAll('.swatches').forEach(function(group){
      var card = group.closest('.vp-piece');
      if(!card) return;
      var pack  = card.querySelector('.vp-piece-img .vp-pack');
      var price = card.querySelector('.vp-piece-price');
      var mat   = card.querySelector('.vp-piece-mat');
      var links = card.querySelectorAll('h3 a, a.vp-tlink');
      var packSrc = pack ? pack.getAttribute('src') : null;

      group.querySelectorAll('.swatch').forEach(function(btn){
        btn.addEventListener('click', function(e){
          e.preventDefault(); e.stopPropagation();

          group.querySelectorAll('.swatch').forEach(function(b){
            b.classList.remove('on'); b.setAttribute('aria-pressed','false');
          });
          btn.classList.add('on'); btn.setAttribute('aria-pressed','true');

          var d = btn.dataset;
          if(pack){
            /* No photograph for this metal: keep the one that is there rather
               than filtering a gold shot until it passes for silver. */
            if(d.img){ pack.removeAttribute('srcset'); pack.src = d.img; }
            else if(packSrc && pack.src !== packSrc){ pack.src = packSrc; }
          }
          /* The hover shot belongs to the chosen metal. No second shot for
             this one means no swap at all, rather than fading to the metal
             that was showing a moment ago. */
          var figure = card.querySelector('.vp-piece-img');
          var life = card.querySelector('.vp-piece-img .vp-life');
          if(figure){
            if(d.life){
              if(!life){
                life = document.createElement('img');
                life.className = 'vp-life';
                life.loading = 'lazy';
                figure.insertBefore(life, figure.firstChild && figure.firstChild.nextSibling);
              }
              life.src = d.life;
              life.alt = '';
              figure.setAttribute('data-swap','');
            } else {
              figure.removeAttribute('data-swap');
              if(life) life.removeAttribute('src');
            }
          }
          if(price && d.price) price.textContent = d.price;
          if(mat && d.mat){ mat.textContent = d.mat; }
          else if(mat && d.value && METAL_RE.test(mat.textContent)){
            mat.textContent = mat.textContent.replace(METAL_RE, d.value);
          }
          if(d.href) links.forEach(function(a){ a.setAttribute('href', d.href); });
        });
      });
    });
  }

  function boot(){ initEdit(document); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function(e){ initEdit(e.target); });
})();